module.exports = __webpack_public_path__ + "img/1121860788.6e6d61ad.png";